// Modules
import axios from 'axios';
import moment from 'moment';
import { useEffect, useState } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';

// CSS
import '_Asset/css/Admin/Page/admin.css'

// Component
import { Pagination } from 'User/Component';
import {
  Paging, // Paging
  CurPageList, // 전체 리스트 정렬 및 현재 페이지 리스트 출력
  SetSortIco, // 정렬 아이콘 변경
  getValueOfKey, // ASC, DESC 정렬 (Str + Num)
  HandleSingleCheck, HandleAllCheck, // 체크박스 단일, 전체 선택
  HighlightedText // 검색어 하이라이팅
} from 'Admin/Component/AdFunc';

// API
import { ApprListApi, ApprApporve, ApprSpecifie, ApprRefer, apiHost } from '_Route/Api';
import Loading from 'Admin/Component/Loading';
import ReceiptPopUp from 'Admin/Component/ReceiptPopUp';


const AdReviewAprvMgt = () => {

  // Using Hooks
  const params = useParams();
  const location = useLocation();
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);
  const [guideStatus, setGuideStatus] = useState(true);
  const [popUpState, setPopUpState] = useState(false)
  const [aprvPageData, setAprvPageData] = useState([]); // ACC Page Data
  const [aprvData, setAprvData] = useState([]); // ACC List Data
  const [curAprvData, setCurAprvData] = useState([]);

  const sessionID = localStorage.getItem('memSessionID')
  const userScore = useSelector(state => state.authorityAcc.access_score);
  // const userRoles = useSelector(state => state.authorityAcc.roles);
  
  // Paging var
  const [curPage, setCurPage] = useState(1) // 현제 페이지
  const blockSize = 10 // Pagination 블럭 갯수
  const [pageSize, setPageSize] = useState(10) // 한 페이지에 노출할 게시물 갯수
  
  // 필터 옵션
  const [filterOpt, setFilterOpt] = useState({
    searchKey: '',
    searchVal: params.key || '',
    approve_req_status: '',
    approve_req_date: '',
    approve_suc_date: '',
  })
  const { searchKey, searchVal, approve_req_status, approve_req_date, approve_suc_date } = filterOpt

  const [curType, setCurType] = useState({name: '검토', key: 'specifie'})
  const btnList = [
    {name: '검토', type: 'specifie'},
    {name: '승인', type: 'approve'},
  ]

  // Column name / Sort var
  const columnList = [
    {name: 'No', key: 'approve_no'},
    {name: '요청유형', key: 'approve_req_cat'}, 
    {name: '요청자', key: 'approve_req'},
    {name: '검토자', key: 'approve_spec'},
    {name: '승인자', key: 'approve_ap'},
    {name: '처리상태', key: 'approve_status'},
    {name: '요청일', key: 'approve_req_date'},
    {name: '완료일', key: 'approve_suc_date'},
  ]; 
  
  const [sortIdx, setSortIdx] = useState(0);
  const [sortType, setSortType] = useState('');
  const [sortState, setSortState] = useState('expand'); // expand, up(DECS), down(ASC);

  // CheckBox var
  const [checkItems, setCheckItems] = useState([]);


  /*========================================================================
  * onHandler Func
  ========================================================================*/
  const onFilter = (e) => {
    const { name, value } = e.target;
    setFilterOpt({...filterOpt, [name]: value});
  }

  const onKeyPress = (e) => { if(e.key == 'Enter') onSearch(); }
  const onSearch = () => {
    navigate(`/admin/review-aprv/mgt${searchVal === '' ? '' : '/' + encodeURIComponent(searchVal)}`);
  }


  /* ========================================================================
  * Axios Review Approve
  ========================================================================*/
  // 검토/승인 리스트 조회
  const getReviewAprv = () => {
    setLoading(false)
    axios({
      url: ApprListApi,
      method: 'GET',
      headers: {
        "Content-Type": "application/json",
        'Authorization': sessionID,
      },
    })
    .then(res => {
      // console.log(res, "GET Review Aprv List Success!")
      const sortData = res.data.result[curType.key];
      
      setAprvPageData(res.data.pageInfo)
      setAprvData(CurPageList(sortData, sortType, sortState, curPage, pageSize))
    })
    .catch(err => {
      console.error("GET Review Aprv List ERROR...", err);
    })
    .finally(() => {
      setLoading(true)
    })
  }

  useEffect(() => {
    getReviewAprv()
  }, [location, pageSize, curPage, sortState, sortIdx, curType, searchKey, approve_req_status, approve_req_date, approve_suc_date])


  // 반영 완료된 요청 적용
  const reflectReviewAprv = (reflectDt) => {
    const { approve_ap_status, approve_spec_status, approve_api_uri, approve_api_method, approve_api_param, approve_uuid } = reflectDt

    const params = JSON.parse(approve_api_param)
    params.approve_ap_status = approve_ap_status;
    params.approve_spec_status = approve_spec_status;
    params.approve_uuid = approve_uuid;

    axios({
      url: apiHost + approve_api_uri,
      method: approve_api_method,
      headers: {
        "Content-Type": "application/json",
        'Authorization': sessionID,
      },
      data: params,
    })
    .then(res => {
      // console.log("Reflect Review Aprv Success!", res)
    })
    .catch(err => {
      console.error("Reflect Review Aprv Error...", err)
    })
  }


  // 검토/승인 완료
  const postReviewAprv = (type) => {
    const curData = type === 'SELECT' ? checkItems : aprvData
    
    if (aprvData.length === 0) {
      alert(`${curType.name}할 요청이 존재하지 않습니다.`)
      return false
    } else if (curData.length === 0 && type === 'SELECT') {
      alert(`${curType.name}할 요청을 선택해주세요.`)
      return false
    }
    if(window.confirm(`${curData.length}개의 ${curType.name} 요청을 모두 ${curType.name}하시겠습니까?`)) {
      curData.map(itm => {
        axios({
          url: curType.key === 'approve' ? ApprApporve : ApprSpecifie,
          method: 'POST',
          headers: {
            "Content-Type": "application/json",
            'Authorization': sessionID,
          },
          data: itm,
        })
        .then(res => {
          // console.log(`POST ${curType.key} Success!`, res)
          const r = res.data.result;
          getReviewAprv()

          // 현재 상태가 반영 완료 일시 해당 내용 반영
          if (r) {
            reflectReviewAprv(r)
          }
        })
        .catch(err => {
          console.error(`POST ${curType.key} ERROR...`, err);
        })
      })
      alert(`요청 ${curType.name}이(가) 완료되었습니다.`)
      setCheckItems([])
    }
  }

  // 검토/승인 반려
  const postRefer = () => {
    if (aprvData.length === 0) {
      alert(`반려할 요청이 존재하지 않습니다.`)
      return false
    } else if (checkItems.length === 0) {
      alert(`반려할 요청을 선택해주세요.`)
      return false
    }
    if(window.confirm(`${checkItems.length}개의 ${curType.name} 요청을 반려하시겠습니까?`)) {
      checkItems.map(itm => {
        axios({
          url: ApprRefer,
          method: 'DELETE',
          headers: {
            "Content-Type": "application/json",
            'Authorization': sessionID,
          },
          data: itm
        })
        .then(res => {
          // console.log(`${curType.key} Request Refer Success!`, res)
          getReviewAprv()
        })
        .catch(err => {
          console.error(`${curType.key} Request Refer ERROR...`, err);
        })
      })
      alert('요청 반려가 완료되었습니다.')
      setCheckItems([])
    }
  }

  // 일괄 삭제 함수
  // const deleteFunc = () => {
  //   if(checkItems.length === 0) {
  //     alert('삭제할 게시물을 선택해주세요.')
  //   } else {
  //     if(window.confirm(`${checkItems.length}개의 게시물을 선택하셨습니다. \n정말 삭제하시겠습니까?`)) {
  //       checkItems.map(id => { postReviewAprv(id) })
  //       setCheckItems([])
  //     }
  //   }
  // }


  return (
    <>
      <div className="adContTitGroup">
        <h2>
          검토/승인 관리
          <span className="textTab">
            {btnList.map((btn, i) => 
              <button key={i} type="button" className={`btn xxs ${curType.name === btn.name ? 'sfrtBlue' : 'blue_edge'} round_10`} onClick={(e) => setCurType({...curType, name: btn.name, key: btn.type})}>{btn.name} 관리</button>
            )}
          </span>
        </h2>
        <p>Home / 검토/승인 / 검토/승인 관리 <button type="button" onClick={() => setGuideStatus(!guideStatus)}><i className="icofont-info-circle" /> 가이드 {guideStatus ? '접기' : '보기'} <i className={`icofont-rounded-${guideStatus ? 'up' : 'down'}`} /></button></p>

        <ul className={`subMsg ${guideStatus ? '' : 'off'}`}>
          <li>* 요청자에게 들어온 <span className="blueTxt">검토/승인 요청</span>을 확인, 관리할 수 있습니다.</li>
          <li>* 왼쪽 체크박스 선택 후 <span className="blueTxt">상단 검토/승인 버튼</span>을 클릭하여 검토/승인을 완료하세요.</li>
          <li>* 요청 유형 항목을 클릭할시 해당 <span className="blueTxt">요청에 대한 정보를 확인</span>할 수 있습니다.</li>
        </ul>
      </div>

      <div className="adContArea list">

        <div className="flexBox end between">
          <div className="adListBox">
            {
              userScore >= 200 &&
              <>
                <button type="button" className="btn xs red round_10" onClick={postRefer}>요청 반려</button>
                <button type="button" className="btn xs sfrtBlue round_10" onClick={() => postReviewAprv('SELECT')}>선택 {curType.name}</button>
                <button type="button" className="btn xs sfrtBlue round_10" onClick={() => postReviewAprv('ALL')}>모두 {curType.name}</button>
              </>
            }
            
            <div className="fieldGroup">
              <label>노출 {curType.name} 수</label>

              <div className="field">
                <select className="select sm type_1 round_10" onChange={(e) => setPageSize(e.target.value)} defaultValue="10">
                  <option value="10">10개 씩</option>
                  <option value="30">30개 씩</option>
                  <option value="50">50개 씩</option>
                  <option value="100">100개 씩</option>
                </select>
              </div>
            </div>

            <div className="fieldGroup">
              <label>처리상태</label>

              <div className="field">
                <select name="approve_req_status" className="select sm type_1 round_10" onChange={(e) => onFilter(e)}>
                  <option value="">전체</option>
                  <option value="미완료">미완료</option>
                  <option value="검토완료">검토완료</option>
                  <option value="승인완료">승인완료</option>
                  <option value="반영완료">반영완료</option>
                  <option value="요청반려">요청반려</option>
                </select>
              </div>
            </div>

            <div className="fieldGroup">
              <label>요청일</label>

              <div className="field">
                <select className="select sm type_1 round_10" name="approve_req_date" onChange={(e) => onFilter(e)}>
                  <option value="">전체</option>
                  <option value="to">오늘</option>
                  <option value="day">어제</option>
                  <option value="week">최근 1주일</option>
                  <option value="month">최근 1개월</option>
                  <option value="year">최근 1년</option>
                </select>
              </div>
            </div>

            <div className="fieldGroup">
              <label>완료일</label>

              <div className="field full">
                <select className="select sm type_1 round_10" name="approve_suc_date" onChange={(e) => onFilter(e)}>
                  <option value="">전체</option>
                  <option value="to">오늘</option>
                  <option value="day">어제</option>
                  <option value="week">최근 1주일</option>
                  <option value="month">최근 1개월</option>
                  <option value="year">최근 1년</option>
                </select>
              </div>
            </div>
          </div>

          <div className="adListBox">
            <div className="fieldGroup row gap">
              <label>{curType.name} 요청 검색</label>

              <div className="field gap">
                <select className="select sm type_1 round_10" name="searchKey" onChange={(e) => onFilter(e)}>
                  <option value="">통합검색</option>
                  <option value="approve_req_cat">요청유형</option>
                  <option value="approve_req">요청자</option>
                  <option value="approve_spec">검토자</option>
                  <option value="approve_ap">승인자</option>
                </select>
                <div className="inputIco">
                  <input type="text" className="input sm type_1 i_rt round_10" name="searchVal" value={searchVal} onChange={(e) => onFilter(e)} onKeyPress={onKeyPress} placeholder="검색어를 입력해주세요." />
                  <button type="button" className="icofont-search" onClick={onSearch}></button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="table list_2">
          <table>
            <thead>
              <tr>
                <th className="check">
                  <div className="checkGroup">
                    <input type="checkbox" className='check sm blue' id="allCheck" onChange={(e) => setCheckItems(HandleAllCheck(e.target.checked, aprvData))} checked={checkItems.length === aprvData.length ? true : false}/>
                    <label htmlFor="allCheck"></label>
                  </div>
                </th>
                {columnList.map((list, i) =>
                  <th key={i} onClick={() => {setSortState(SetSortIco(i, sortIdx, sortState)); setSortIdx(i); setSortType(list.key)}}>{list.name}<i className={`icofont-rounded-${i === sortIdx ? sortState : 'expand'}`}></i></th>
                )}
              </tr>
            </thead>
            <tbody>
              {loading ?
                aprvData.length !== 0 ?
                  aprvData.map((data, i) => 
                    <tr key={i}>
                      <td>
                        <div className="checkGroup">
                          <input type="checkbox" className='check sm blue' id={`check_${i}`} onChange={(e) => setCheckItems(HandleSingleCheck(e.target.checked, data, checkItems))} checked={checkItems.includes(data) ? true : false}/>
                          <label htmlFor={`check_${i}`}></label>
                        </div>
                      </td>
                      <td>{data.approve_no}</td>
                      <td><button type="button" style={{textDecoration: 'underline'}} onClick={() => {setPopUpState(true); setCurAprvData(data)}}>{data.approve_req_cat}</button></td>
                      <td>{data.approve_req}</td>
                      <td>{data.approve_spec}</td>
                      <td>{data.approve_ap}</td>
                      <td className={`status_${data.approve_status_int}`}>{data.approve_status}</td>
                      <td>{moment(data.approve_req_date).format('YYYY-MM-DD HH:mm')}</td>
                      <td>{data.approve_suc_date === null ? '-' : moment(data.approve_suc_date).format('YYYY-MM-DD HH:mm')}</td>
                    </tr>
                  )
                  :
                  <tr>
                    <td colSpan={columnList.length + 1}>
                      <div className="noData">
                        <i className="icofont-warning-alt"></i>
                        <p>{curType.name} 요청이 존재하지 않습니다.</p>
                      </div>
                    </td>
                  </tr>
                :
                <tr><td colSpan={columnList.length + 1}><Loading type="tbLoad" /></td></tr>
              }
            </tbody>
          </table>
        </div>

        <div className="flexBox between paginationBox">
          <p>Showing {curPage} to {pageSize} of {aprvPageData.count} entries</p>

          <Pagination
            type="type_1"
            size="sm"
            curPage={curPage}
            setCurPage={setCurPage}
            pageSize={pageSize}
            blockSize={blockSize}
            startBlock={Paging(curPage, blockSize, pageSize, aprvPageData.count).startBlock}
            endBlock={Paging(curPage, blockSize, pageSize, aprvPageData.count).endBlock}
            pageCount={Paging(curPage, blockSize, pageSize, aprvPageData.count).pageCount}
          />
        </div>
      </div>

      {/* 요청 유형 팝업 */}
      <ReceiptPopUp
        popUpState={popUpState}
        setPopUpState={setPopUpState}
        curData={curAprvData}
      />
    </>
  )
}

export default AdReviewAprvMgt